<template>
  <span
    class="indicator"
    :class="classes"
    v-if="$router.history.current.name === 'pipelines' || (status !== 'pause' && status !== 'stop' && status !== 'run')"
  >
    {{ status }}
  </span>
</template>

<script>
export default {
  name: 'PipelineStatusIndicator',
  props: ['status'],
  computed: {
    classes() {
      switch (this.status) {
        case 'processing':
          return 'has-text-grey'
        case 'pause':
          return 'has-text-grey'
        case 'in queue':
          return 'has-text-info'
        case 'run':
          return 'has-text-success'
        default:
          return 'has-text-danger'
      }
    }
  }
}
</script>

<style scoped></style>
